require './scripts/init'



/** WEBPACK FOOTER **
 ** ./~/cjsx-loader!./src/app.cjsx
 **/